import { Component, OnInit } from '@angular/core';

import { FormFieldComponent } from '../form-field/form-field.component';
import _ from 'lodash';
import { forOwn } from 'lodash';
import { get } from 'lodash';
import { map } from 'lodash';

@Component({
  selector: 'app-form-field-multiselect',
  templateUrl: './form-field-multiselect.component.html',
  styleUrls: ['./form-field-multiselect.component.scss'],
})
export class FormFieldMultiselectComponent
  extends FormFieldComponent
  implements OnInit
{
  selected: any;
  items: any[] = [];

  override ngOnInit(): void {
    if (
      this.group.name === 'care level' &&
      this.section.formReference === 'memory_care'
    ) {
      const opt = get(this.question, 'options[0].jsonValue', null);
      if (opt) {
        const val = _.values(opt);
        this.selected = get(val, '[0]');
      }
    }

    super.ngOnInit();
    map(this.question.options, x =>
      forOwn(x.jsonValue, (v, k) => {
        this.items.push({
          key: k,
          value: v,
        });
      })
    );
  }
}
